import React from "react";
import classes from "./CardTouch.module.scss";
import Card from "@mui/material/Card";
import { CardActionArea } from "@mui/material";
import Zoom from "@mui/material/Zoom";

const CardTouch = ({
  onClick = null,
  children,
  classPrimary = "",
  transitionDelay = 100,
  ...rest
}) => {
  // const transitionDelay = 100;

  return (
    <Zoom in={true} style={{ transitionDelay: `${transitionDelay}ms` }}>
      <CardActionArea
        onClick={onClick}
        className={`${classes.CardTouch} ${classPrimary}`}
        {...rest}
      >
        {children}
      </CardActionArea>
    </Zoom>
  );
};

export default CardTouch;
